import {
  Directive,
  OnDestroy,
  AfterViewInit,
  Input,
  TemplateRef,
  Output,
  EventEmitter,
  ComponentRef,
  ViewContainerRef,
  ElementRef,
  Renderer2
} from '@angular/core';
import { ComponentsHelperService } from '../../services/components-helper.service';
import { TooltipOptions, TOOLTIP_OPTIONS } from '../../models/tooltip-options';
import { TooltipContainerComponent } from '../../components/tooltip-container/tooltip-container.component';

@Directive({
  selector: '[muniGamedayTooltip], [muniGamedayTooltipHtml]',
  exportAs: 'tooltip'
})
export class TooltipDirective implements OnDestroy, AfterViewInit {
  /* eslint-disable @angular-eslint/no-input-rename */
  @Input('tooltip')
  public content: string;
  @Input('tooltipHtml')
  public htmlContent: string | TemplateRef<string>;
  @Input('tooltipPlacement')
  public placement = 'top';
  @Input('tooltipEnable')
  public enable = true;
  @Input('tooltipAnimation')
  public animation = true;
  @Input('tooltipAppendToBody')
  public appendToBody: boolean;
  @Input('tooltipClass')
  public popupClass: string;
  @Input()
  public tooltipContext: any;
  @Input()
  public tooltipTrigger = 'mouseenter';
  @Input()
  public disableTooltipTrigger = 'mouseleave';
  @Input()
  public clickOutsideEnabled = false;
  @Output()
  public readonly isOpen: EventEmitter<any> = new EventEmitter();
  /* eslint-enable @angular-eslint/no-input-rename */

  private visible = false;
  private tooltip: ComponentRef<any>;
  private enableTriggerFunc: () => void;
  private disableTriggerFunc: () => void;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private componentsHelper: ComponentsHelperService,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  public ngOnDestroy(): void {
    this.enableTriggerFunc();
    this.disableTriggerFunc();
  }

  public ngAfterViewInit(): void {
    this.enableTriggerFunc = this.renderer.listen(
      this.elementRef.nativeElement,
      this.tooltipTrigger,
      () => {
        if (!this.visible) {
          this.show();
        }
      }
    );

    if (this.clickOutsideEnabled) {
      this.disableTriggerFunc = this.renderer.listen(
        this.elementRef.nativeElement,
        'clickOutside',
        () => {
          if (this.visible) {
            this.hide();
          }
        }
      );
    } else {
      this.disableTriggerFunc = this.renderer.listen(
        this.elementRef.nativeElement,
        this.disableTooltipTrigger,
        () => {
          if (this.visible) {
            this.hide();
          }
        }
      );
    }
  }

  public show(): void {
    if (this.visible || !this.enable) {
      return;
    }

    this.visible = true;
    this.isOpen.emit(true);

    const options: TooltipOptions = {
      content: this.content,
      htmlContent: this.htmlContent,
      placement: this.placement,
      animation: this.animation,
      hostEl: this.viewContainerRef.element,
      popupClass: this.popupClass,
      context: this.tooltipContext
    };

    const binding = [{ provide: TOOLTIP_OPTIONS, useValue: options }];

    this.tooltip = this.componentsHelper.appendNextToLocation(
      TooltipContainerComponent,
      this.viewContainerRef,
      binding
    );
  }

  public hide(): void {
    if (!this.visible) {
      return;
    }
    this.visible = false;
    this.isOpen.emit(false);
    this.tooltip.destroy();
  }
}
